import React from 'react';
import { CreditCard, Banknote, ArrowLeft, MapPin, Tag, X, Check, Gift, Store, Truck, Clock, Plus, ChevronRight, Trash2, Phone, CalendarDays } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { RadioGroup, RadioGroupItem } from '../ui/radio-group';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Separator } from '../ui/separator';
import { formatPrice } from '../../lib/utils';
import StampCard from '../StampCard';

// TEMPORARY: set to true to re-enable the delivery option
const DELIVERY_ENABLED = false;

const OrderTypeCard = ({
  orderType,
  setOrderType,
  t,
}) => (
  <>
              <Card className="bg-[#141417] border-[#27272A]">
                <CardHeader>
                  <CardTitle>{t('checkout.orderType')}</CardTitle>
                </CardHeader>
                <CardContent>
                  {!DELIVERY_ENABLED && (
                    <p data-testid="delivery-unavailable-notice" className="text-sm text-[#FFC107] mb-3 flex items-center gap-2">
                      <Truck className="h-4 w-4" />
                      {t('checkout.deliveryUnavailable')}
                    </p>
                  )}
                  <RadioGroup value={orderType} onValueChange={setOrderType}>
                    {DELIVERY_ENABLED && (
                    <Label htmlFor="delivery" className={`flex items-center space-x-3 p-4 rounded-lg border cursor-pointer transition-colors ${orderType === 'delivery' ? 'border-[#FFC107]' : 'border-[#27272A] hover:border-[#FFC107]/50'}`}>
                      <RadioGroupItem value="delivery" id="delivery" data-testid="order-type-delivery" />
                      <div className="flex items-center gap-3 flex-1">
                        <Truck className="h-5 w-5 text-[#FFC107]" />
                        <div>
                          <p className="font-medium">{t('checkout.delivery')}</p>
                          <p className="text-sm text-zinc-400">{t('checkout.deliveryDesc')}</p>
                        </div>
                      </div>
                    </Label>
                    )}
                    <Label htmlFor="pickup" className={`flex items-center space-x-3 p-4 rounded-lg border cursor-pointer transition-colors mt-3 ${orderType === 'pickup' ? 'border-[#FFC107]' : 'border-[#27272A] hover:border-[#FFC107]/50'}`}>
                      <RadioGroupItem value="pickup" id="pickup" data-testid="order-type-pickup" />
                      <div className="flex items-center gap-3 flex-1">
                        <Store className="h-5 w-5 text-[#FFC107]" />
                        <div>
                          <p className="font-medium">{t('checkout.pickup')}</p>
                          <p className="text-sm text-zinc-400">{t('checkout.pickupDesc')}</p>
                        </div>
                      </div>
                    </Label>
                  </RadioGroup>
                </CardContent>
              </Card>
  </>
);

export default OrderTypeCard;
